<template>
  <el-row :gutter="15">
    <el-col
      :xs="12"
      :sm="8"
      :md="7"
      :lg="6"
      :xl="4"
    >
      <el-card
        shadow="never"
        header="Account Exports"
      >
        <el-menu
          :default-active="activeList"
          class="border-0"
          @select="index => { activeList = index }"
        >
          <el-menu-item index="Addressbook">
            <FontAwesomeIcon
              :icon="[ 'fal', 'users' ]"
              size="lg"
            />
            <span class="pl-3">Address Book Export</span>
          </el-menu-item>

          <el-menu-item index="Items">
            <FontAwesomeIcon
              :icon="[ 'fal', 'boxes' ]"
              size="lg"
            />
            <span class="pl-3">Item Export</span>
          </el-menu-item>

          <el-menu-item index="DG">
            <FontAwesomeIcon
              :icon="[ 'fal', 'biohazard' ]"
              size="lg"
            />
            <span class="pl-3">DG Item Export</span>
          </el-menu-item>

          <el-menu-item index="AccountPortfolio">
            <FontAwesomeIcon
              :icon="[ 'fal', 'users' ]"
              size="lg"
            />
            <span class="pl-3">Account Portfolio</span>
          </el-menu-item>

          <el-menu-item index="CustomerGrade">
            <FontAwesomeIcon
              :icon="[ 'fal', 'users' ]"
              size="lg"
            />
            <span class="pl-3">Customer Grade</span>
          </el-menu-item>

          <el-menu-item index="ScheduledPickups">
            <FontAwesomeIcon
              :icon="[ 'fal', 'users' ]"
              size="lg"
            />
            <span class="pl-3">Scheduled Pickups</span>
          </el-menu-item>
        </el-menu>
      </el-card>
    </el-col>

    <el-col
      :xs="12"
      :sm="16"
      :md="17"
      :lg="18"
      :xl="20"
    >
      <el-card shadow="never">
        <template #header>
          <span>{{ `${$filters.titleize(activeList)} Report` }}</span>
        </template>
        <component
          :is="activeList"
          ref="list"
        />
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import Addressbook from '@/components/Application/Reports/Account/Addressbook'
import DG from '@/components/Application/Reports/Account/DG'
import Items from '@/components/Application/Reports/Account/Items'
import AccountPortfolio from '@/components/Application/Reports/Account/AccountPortfolio'
import CustomerGrade from '@/components/Application/Reports/Account/CustomerGrade'
import ScheduledPickups from '@/components/Application/Reports/Account/ScheduledPickups'

export default {
  components: {
    DG,
    Addressbook,
    Items,
    AccountPortfolio,
    CustomerGrade,
    ScheduledPickups
  },
  data () {
    return {
      title: 'Account Exports',
      breadcrumb: {
        name: 'Account Exports',
        route: { name: 'reports-account' }
      },
      activeList: 'Addressbook'
    }
  }
}
</script>
